import {ConfigObjectType, ExportUtils, useCurrentLocale} from '@wallaby-ui/core';
import {useCallback, useMemo} from 'react';

import {useUzisReportParams} from './uzisReportApi';
import {UzisReportFilter} from './uzisreporttypes';

export function useUzisReportExport(filters: UzisReportFilter, config: ConfigObjectType) {
  const currentLocale = useCurrentLocale();
  const params = useUzisReportParams(filters);

  const exportFilters = useMemo(() => params, [params]);

  const handleXlsxExport = useCallback(() => {
    ExportUtils.handleExportXlsx({
      url: config.service.url.uzisReportExport,
      filters: exportFilters as any,
      locale: currentLocale,
    });
  }, [config.service.url.uzisReportExport, exportFilters, currentLocale]);

  return {handleXlsxExport};
}
